<script>
  import { format } from "d3-format";
  export let gridType;
  export let scale;
  export let innerHeight;
  export let innerWidth;
  export let ticks;
  export let numberFormat;
</script>

{#if gridType == "xGrid"}
  {#each ticks as tick}
    <line
      x1={scale(tick)}
      x2={scale(tick)}
      y1={0}
      y2={innerHeight}
      class="gridline"
    />
    <text x={scale(tick)} y={innerHeight + 20} class="ticklabel x"
      >{format(numberFormat)(tick)}</text
    >
  {/each}
{/if}

{#if gridType == "yGrid"}
  {#each ticks as tick}
    <line
      x1={0}
      x2={innerWidth}
      y1={scale(tick)}
      y2={scale(tick)}
      class="gridline"
    />
    <text x={-20} y={scale(tick) + 5} class="ticklabel">{tick}</text>
  {/each}
{/if}

<style>
  line.gridline {
    stroke-width: 1px;
    stroke: #ccc;
    stroke-dasharray: 4;
  }
  text.ticklabel {
    font-size: 11px;
    fill: #aaaaaa;
  }
  text.ticklabel.x {
    text-anchor: middle;
  }
</style>
